export default "__VITE_ASSET__D6r6_2vX__"